import styled from "styled-components";

const SVGWrapper = styled.svg`
  width: 120px;
  @media (max-width: 640px) {
    width: 100px;
  }
`;

const Blueprint_Logo = () => {
  return (
    <SVGWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 102">
      <g id="Layer_2" data-name="Layer 2" fill="#253569">
        <g id="Layer_1-2" data-name="Layer 1">
          <g id="Shape_1_copy_2" data-name="Shape 1 copy 2">
            <path
              d="M51,102A51,51,0,0,1,22.48,8.71,51.54,51.54,0,0,1,31.15,4a51.07,51.07,0,0,1,39.7,0A51.05,51.05,0,0,1,98,31.15a51.07,51.07,0,0,1,0,39.7A51.05,51.05,0,0,1,70.85,98,50.94,50.94,0,0,1,51,102ZM51,1.38a49.89,49.89,0,0,0-10,1,48.75,48.75,0,0,0-9.31,2.89,49.41,49.41,0,0,0-8.43,4.57A49.74,49.74,0,0,0,9.85,23.26a49.41,49.41,0,0,0-4.57,8.43A48.75,48.75,0,0,0,2.39,41a50,50,0,0,0,0,20,48.75,48.75,0,0,0,2.89,9.31,49.41,49.41,0,0,0,4.57,8.43A49.74,49.74,0,0,0,23.26,92.15a49.41,49.41,0,0,0,8.43,4.57A48.75,48.75,0,0,0,41,99.61a50,50,0,0,0,20,0,48.75,48.75,0,0,0,9.31-2.89,49.41,49.41,0,0,0,8.43-4.57A49.74,49.74,0,0,0,92.15,78.74a49.41,49.41,0,0,0,4.57-8.43A48.75,48.75,0,0,0,99.61,61a50,50,0,0,0,0-20,48.75,48.75,0,0,0-2.89-9.31,49.41,49.41,0,0,0-4.57-8.43A49.74,49.74,0,0,0,78.74,9.85a49.41,49.41,0,0,0-8.43-4.57A48.75,48.75,0,0,0,61,2.39,49.89,49.89,0,0,0,51,1.38Z"
            />
          </g>
          <g id="blueprint_copy" data-name="blueprint copy">
            <path
              d="M21.25,47.42a5.22,5.22,0,0,1-3.71,8.93A5.09,5.09,0,0,1,14,55a5,5,0,0,1-1.66-3.37h0V40.71H14.4V47a5,5,0,0,1,3.13-1A5,5,0,0,1,21.25,47.42ZM15.3,48.91a3.23,3.23,0,0,0,0,4.47,3.25,3.25,0,0,0,4.47,0A3.14,3.14,0,0,0,17.54,48a3,3,0,0,0-2.24.9ZM26,40.63V56.27H23.89V40.63Zm11.57,5.29v5.22a5.25,5.25,0,0,1-8.92,3.71,5,5,0,0,1-1.5-3.71V45.92H29.2v5.22a3.13,3.13,0,1,0,6.26,0V45.92ZM42.1,53.7a3.09,3.09,0,0,0,1.81.57h4.68v2.11H43.88v0A5.24,5.24,0,1,1,49,50.1l-1.3,2.1H41A3,3,0,0,0,42.1,53.7Zm0-5.12A3.08,3.08,0,0,0,41,50.08h5.89A3.12,3.12,0,0,0,43.91,48a3.16,3.16,0,0,0-1.81.57Zm17-1.24a5.08,5.08,0,0,1,1.49,3.72,5.12,5.12,0,0,1-5.21,5.21,5.1,5.1,0,0,1-3.13-1v6.26H50.16l0-10.78a2.17,2.17,0,0,1,0-.36,5,5,0,0,1,1.64-3.18,5.06,5.06,0,0,1,3.52-1.32A5,5,0,0,1,59.09,47.34Zm-6,1.48a3.23,3.23,0,0,0,0,4.47,3.14,3.14,0,1,0,0-4.47ZM69,46.33a2,2,0,0,1-.46.88c-.3.41-.51.7-.63.85a2.88,2.88,0,0,0-.92-.13,3,3,0,0,0-3.14,3.13v5.21H61.72V51.06a5.11,5.11,0,0,1,5.22-5.21,5.25,5.25,0,0,1,1.92.34.13.13,0,0,1,.09.14Zm2.47-.49V56.27H69.34V45.84Zm0-3.65v2.08H69.34V42.19ZM81.5,47.34A5.05,5.05,0,0,1,83,51.06v5.21H80.92V51.06a3,3,0,0,0-.9-2.24,3.26,3.26,0,0,0-4.48,0,3.06,3.06,0,0,0-.89,2.24v5.21H72.57V51.06a5.11,5.11,0,0,1,5.22-5.21,5,5,0,0,1,3.71,1.49Zm7.86-1.94v2.09H86.22v8.86H84.14V40.71h2.08V45.4Z"
            />
          </g>
          <g id="film_copy" data-name="film copy">
            <path
              d="M39.6,81.59h3.18v-.84H39.6V78.57H43v-.86H38.63v7h1V81.59Zm6.81-3.88h-1v7h1Zm3.86,0h-1v7h4.1v-.87H50.27V77.71Zm6.78,0H55.53v7h.95V78.86h0l2.31,5.85h.63l2.32-5.85h0v5.85h1v-7H61.24l-2.07,5.38h0Z"
            />
          </g>
          <path
            d="M52.93,68.37a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,52.93,68.37Z"
          />
          <g id="Ellipse_3_copy" data-name="Ellipse 3 copy">
            <circle cx="49.07" cy="69.57" r="1.2" />
          </g>
        </g>
      </g>
    </SVGWrapper>
  );
};

export default Blueprint_Logo
